import React from 'react';
import moment from 'moment';
import { DatePicker } from 'antd';



class DatePickerMoment extends React.Component {
  render() {
    const value = this.props.value ? moment(this.props.value) : null;
    const props = {
      ...this.props,
      value,
    };
    return <DatePicker {...props} />;
  }
}

export default DatePickerMoment;


// WEBPACK FOOTER //
// ./src/components/DatePicker/index.jsx